import { Component, Inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InfoDialogConfig } from './info-dialog.types';

@Component({
    selector: 'info-dialog',
    templateUrl: './info-dialog.component.html',
    styles: [
        /* language=SCSS */
        `
            .info-dialog-panel {
                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {

                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InfoDialogComponent {
    /**
     * Constructor
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: InfoDialogConfig,
        public matDialogRef: MatDialogRef<InfoDialogComponent>
    ) { }

}
